import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import dayjs from 'dayjs';
import uk from 'dayjs/locale/uk';
import { App } from './App';
import './styles/global.css';

// F-190 QA: explicit `dayjs.locale('uk', uk)` because Vite tree-shakes the
// side-effect-only `import 'dayjs/locale/uk'` form.
dayjs.locale('uk', uk);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
